import { __decorate } from "tslib";
import { LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map.js';
import '../typography/tg-body-two';
import { generateCustomColors } from './helpers';
import styles from './styles';
/**
 * @dependency amityeko-tg-body-two
 *
 * @slot - Badge's label.
 * @slot icon - The icon to be shown on the left side (amityeko-icon is expected).
 */
export default class AmityekoBadge extends LitElement {
    constructor() {
        super(...arguments);
        this.variant = 'default';
    }
    render() {
        const normalizedVariant = !this.color ? this.variant : 'custom';
        return html `
      <div
        class="badge badge--variant-${normalizedVariant}"
        style=${styleMap({ ...generateCustomColors(this.color) })}
      >
        <slot name="icon"></slot>
        <amityeko-tg-body-two class="badge__label"><slot></slot></amityeko-tg-body-two>
      </div>
    `;
    }
}
AmityekoBadge.styles = styles;
__decorate([
    property()
], AmityekoBadge.prototype, "variant", void 0);
__decorate([
    property()
], AmityekoBadge.prototype, "color", void 0);
if (!customElements.get('amityeko-badge')) {
    customElements.define('amityeko-badge', AmityekoBadge);
}
//# sourceMappingURL=index.js.map